module.exports = __webpack_public_path__ + "img/client-block-image-img.a3c0e7d.jpg";